/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import uiConf from "../../config/uiConf";

import Dialog from "../dialog/functional/Dialog";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogContent from "../dialog/functional/DialogContent";
import AutoForm from "../form/functional/AutoForm";
import getSchema from "../../lib/api/getSchema";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";
import apiClient from "../../lib/common/apiClient";

function TkSelectionProcessInCreateTempleteDialog ( props ) {

    const { t } = useTranslation ();

    const table = "TkProcessTemplete";

    const {

        id,

        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,
        processList,
        onCreateTemplete,

        ...others

    } = props;

    const [instance, setInstance] = useState ();
    const [ notification, setNotification ] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const [schema, setSchema] = useState();

    const [formData, setFormData]  = useState();

    const [diabledButton, setDisabledButton] = useState(true);

    useEffect ( () => {

        let mounted = true;

        ( async () => {

            let schema = await getSchema ( table );
            
            if ( mounted ) {
                setSchema(schema);
            }
        } ) ();

        return ( () => {
            mounted = false;
        } );

    }, [table] );

    const nofifyWarning = (msg) => {

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const checkItemValidataion = ( schema, formData ) => {

        for ( const column of schema.columns ) {

            let [valid, msg] = checkValidation ( "create", column, column.validation, formData[column.name] || "" );

            if ( !valid ) {

                nofifyWarning ( msg );
                return false;

            }
            
        }

        return true;

    }

   

    const onDialogInitialized = ( instance ) => {

        setInstance ( instance );
        
        if ( onInitialized ) {

            onInitialized ( instance );
            
        }

    };

    const onCloseDialog = () => {

        if ( onClose ) {

            onClose ();
            
        }
        setFormData([]);

    };

    const onCloseNotification = () => {

        setNotification( ( notification ) => {

            return ({...notification, open: false});

        } );

    };

    const onChange = (data) => {

        setFormData(data);

        setDisabledButton(false);

    }

    const onCancel = () => {

        setFormData([]);

        instance.hide();

    };

    const notifyFailure = (msg) => {

        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onApiSuccess = (result) => {
        
        if (onSuccess) {

            setTimeout ( onSuccess(result.data.text), 0 );

        }

        setFormData([]);
        setDisabledButton(true);
        onCreateTemplete(result.data.templeteId);
        
        instance.hide();

    };

    const onApiFailure = (reason) => {

        setDisabledButton(true);
        notifyFailure ( t ( "error.insertFailure", { reason: reason.response ? reason.response.data : JSON.stringify ( reason ) } ) );
    };


    const onOk = ( formData, processList ) => {
        
        if ( ! checkItemValidataion ( schema, formData ) ) {

            console.error ( "Form Validation Failed" );

            return;

        }

        if (schema.validation) {

            let [valid, msg] = checkConditionWithMsg(

                formData,
                schema.validation

            );

            if (!valid) {

                nofifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;

            }
        }

        let url = `/api/${schema.name}`;

        let apiData = { ...formData, ...processList };
        let form = new FormData ();
        let json = {};
        let deleted = {};

        for ( const formItem in apiData ) {

            if ( apiData[formItem] !== undefined ) {
    
                json[formItem] = apiData[formItem];
            }
        }

        form.append ( "deleted", JSON.stringify ( deleted ) );
        form.append ( "json", JSON.stringify ( json ) );
        apiClient
            .post(url, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));
    }

    return (

        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth={maxWidth ? maxWidth : uiConf.confirmDialogMaxWidth}
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >

            <DialogHeaderWithClose>
                <DialogTitle>
                    { t ( "dialog.title.TkProcessTemplete.create" ) }
                </DialogTitle>
            </DialogHeaderWithClose>

            <DialogContent dividers>

                <AutoForm
                    id="templete-create-form"
                    schema={schema}
                    mode="create"
                    initialData={formData}
                    onChange={onChange}
                />
                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >
                    <Alert
                        onClose={onCloseNotification}
                        variant="filled"
                        severity={notification.severity}
                    >
                        {notification.msg}
                    </Alert>
                </Snackbar>
            </DialogContent >

            <DialogActionsOkCancel
                labels={[ t("common.ok")]}
                buttonDisabled={[diabledButton, false]}
                onOk={() => onOk(formData, processList)}
                onCancel={onCancel}
            />

        </Dialog>

    );

}

export default TkSelectionProcessInCreateTempleteDialog;
